import React from "react";

function CancelledIcon() {
  return (
    <span className="anticon anticon-cancelled">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        viewBox="0 0 22 22"
      >
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M11 0c6.075 0 11 4.925 11 11s-4.925 11-11 11S0 17.075 0 11 4.925 0 11 0zm0 2a9 9 0 10.001 18.001A9 9 0 0011 2zm5 8v2H6v-2h10z"
        ></path>
      </svg>
    </span>
  );
}

export default CancelledIcon;
